import React, { useEffect, useState } from 'react';
import RichText, { RichTextProps } from '../RichText/RichText';
import { motion, AnimatePresence } from 'framer-motion';
import { getAnimationVariants } from '../../../../helpers/animations';

type SectionElementAnimatedProps = {
  animation: keyof ReturnType<typeof getAnimationVariants>;
  content: RichTextProps[];
  isLooped?: boolean;
  isPlaying: boolean;
};

let isFirstRender = true;

const SectionElementAnimated: React.FC<SectionElementAnimatedProps> = ({
  isLooped,
  isPlaying,
  content,
  animation,
}) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    isFirstRender = false;
    const interval = setInterval(() => {
      setIndex(current => {
        if (!isLooped && current + 1 === content.length) {
          clearInterval(interval);
          return current;
        }
        return (current + 1) % content.length;
      });
    }, 2000);

    if (!isPlaying) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [content, isPlaying]);

  return (
    <div>
      <div style={{ overflow: 'hidden' }}>
        <AnimatePresence exitBeforeEnter>
          <motion.div
            key={`${content[index].id}_${index}`}
            transition={{
              type: 'keyframes',
            }}
            {...getAnimationVariants(isFirstRender)[animation]}
          >
            <RichText
              {...content[index]}
              noMargin
              rawRichText={content[index].text?.raw}
            />
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default SectionElementAnimated;
